import React from 'react';
import { ContextBarContextType } from './types';

const ContextBarContext = React.createContext<ContextBarContextType | null>(
  null,
);

export default ContextBarContext;
